var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("Loading publications...")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }